import {useAuthEffect, useIsAuthenticatedValue} from '@/auth/hooks/useIsAuthenticated'
import {getCartQueryKey, getCartQueryOptions} from '@/lib/cart/hooks/useCart'
import {useLocale} from '@/lib/locale/locale'

export default memo(function CartEffects() {
  const [locale] = useLocale()
  const isAuthenticated = useIsAuthenticatedValue()

  useQuery(getCartQueryOptions({locale, isAuthenticated}))

  const queryClient = useQueryClient()
  const invalidateCart = useCallback(() => {
    queryClient
      .invalidateQueries({
        queryKey: getCartQueryKey({locale}),
        exact: true,
      })
      .catch(() => {
        // do nothing
      })
  }, [queryClient, locale])

  // invalidate cart
  useAuthEffect(invalidateCart)

  return null
})
